import { drawStyle } from '@components/map/layers/draw/polygons/DrawPolygonLayer';
import { DrawControl, MapboxDrawControl } from '@components/ui/map/formMap/DrawControl';
import { EditableGeometry, useFormMapContext } from '@components/ui/map/formMap/FormMapContext';
import { useDrawMapCursor } from '@components/ui/map/formMap/useMapCursor';
import { DrawMode } from '@mapbox/mapbox-gl-draw';
import { useRef } from 'react';

import { MapBoxDrawEvent } from '@/types/map.types';

const isDrawLayer = (id: string) => id.startsWith('gl-draw');

type DrawLayerProps = {
  drawMode: DrawMode;
};

function DrawLayer({ drawMode = 'draw_polygon' }: Readonly<DrawLayerProps>) {
  const drawRef = useRef<MapboxDrawControl | null>(null);
  const { cursorMode, geometry, updateGeometry } = useFormMapContext();

  useDrawMapCursor(cursorMode, drawRef, isDrawLayer);

  const onCreateDraw = (evt: { features: MapBoxDrawEvent[] }) => {
    updateGeometry(evt.features[0].geometry as EditableGeometry);
  };

  const onUpdateDraw = (evt: { features: MapBoxDrawEvent[]; action: string }) => {
    updateGeometry(evt.features[0].geometry as EditableGeometry);
  };

  return (
    <DrawControl
      drawRef={drawRef}
      position="top-left"
      displayControlsDefault={false}
      controls={{
        point: false,
        line_string: false,
        polygon: false,
        trash: false,
        combine_features: false,
        uncombine_features: false,
      }}
      defaultMode={drawMode}
      styles={drawStyle}
      onCreate={onCreateDraw}
      onUpdate={onUpdateDraw}
      geometry={geometry}
    />
  );
}

export default DrawLayer;
